import PropTypes from "prop-types"

import Button from "components/ui/button"
import { cn } from "styles/utils"

export const TextColored = ({ className, ...props }) => (
  <p className={cn("text-primary", className)} {...props} />
)

export const AccordionHeading = ({ className, ...props }) => (
  <Button
    className={cn("w-full items-center justify-between", className)}
    {...props}
  />
)

AccordionHeading.propTypes = {
  className: PropTypes.string,
}

TextColored.propTypes = {
  className: PropTypes.string,
}
